module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin21-d8cf287b8dfb5927e8c80b682a5ad441.jpg";